import { StorageService } from './storage-service';

export const localStore = new StorageService(localStorage);
export const sessionStore = new StorageService(sessionStorage);
